// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__2zNWA","shimmer":"Skeleton_shimmer__R4kMk"};